<template>
  <div style="background-color: #F5F5F5">
    <v-img
      class="white--text"
      :contain="true"
      height="120px"
      :src="require('@/assets/img/Manuello_Design.png')"
    ></v-img>

    <v-card-title primary-title class="pt-0 pb-0">
      <div
        style="
          color: gray;
          letter-spacing: 2px;
          width: 100%;
          text-align: center;
          cursor: pointer;
        "
      >
        <span v-on:click="goToHome">AREA RISERVATA</span>
      </div>
    </v-card-title>

    <div style="height: 3px">
      <v-progress-linear
        indeterminate
        v-show="loading"
        height="3"
        style="margin: 0px"
      ></v-progress-linear>
    </div>

    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
  },

  methods: {
    goToHome: function () {
      this.$emit("goToHome");
    },
  },
};
</script>




